"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DividerV2 = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const dividerSizes = {
    small: "1px",
    medium: "2px",
    large: "4px"
};
const DividerV2 = ({ color, direction = "horizontal", size = "small", sx }) => {
    const dividerStyles = Object.assign({ borderColor: color ? color : "stroke-neutral-default", borderStyle: "solid", display: "block" }, (direction === "horizontal"
        ? {
            borderWidth: `${dividerSizes[size]} 0 0 0`,
            width: "100%",
            height: "auto"
        }
        : {
            borderWidth: `0 0 0 ${dividerSizes[size]}`,
            height: "100%",
            width: "auto"
        }));
    const computedAs = direction === "horizontal" ? "hr" : "div";
    return (react_1.default.createElement(foundations_1.Box, { as: computedAs, sx: Object.assign(Object.assign({}, dividerStyles), sx) }));
};
exports.DividerV2 = DividerV2;
//# sourceMappingURL=Divider.js.map